<template>
  <div class="dropdown"
       :class="isSelected ? 'selected' : ''">

    <span @click="reset()"
          v-show="isSelected"
          class="dropdown-reset">
      <i class="fa fa-close"></i>
    </span>

    <input class="dropdown-input"
           :name="name"
           @focus="showOptions()"
           @blur="blur()"
           @keyup="keyMonitor"
           v-model="searchFilter"
           :disabled="disabled"
           :placeholder="placeholder"/>

    <div class="dropdown-content"
         v-show="optionsShown">
      <div
          class="dropdown-item"
          @mousedown="selectOption(option)"
          v-for="(option, index) in filteredOptions"
          :key="index">
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Dropdown',
  template: 'Dropdown',
  props: {
    name: {
      type: String,
      required: false,
      default: 'dropdown',
      note: 'Input name'
    },
    options: {
      type: Array,
      required: true,
      default: [],
      note: 'Options of dropdown. An array of options',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please select an option',
      note: 'Placeholder of dropdown'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    maxItem: {
      type: Number,
      required: false,
      default: 6,
      note: 'Max items showing'
    }
  },
  data() {
    return {
      selected: '',
      isSelected: false,
      optionsShown: false,
      searchFilter: '',
    }
  },
  mounted() {
    this.emitter.on('reset-dropdowns', msg => {
      this.reset();
    });
  },
  created() {
    this.$emit('selected', this.selected);
  },
  computed: {
    filteredOptions() {
      const filtered = [];
      const regOption = new RegExp(this.searchFilter, 'ig');
      for (const option of this.options) {
        if (this.searchFilter.length < 1 || option.match(regOption)) {
          if (this.maxItem === -1) {
            filtered.push(option);
          } else if (filtered.length < this.maxItem) {
            filtered.push(option);
          }
        }
      }
      return filtered;
    }
  },
  methods: {
    selectOption(option) {
      this.selected = option;
      this.$nextTick(() => {
        this.isSelected = true;
      });
      this.optionsShown = false;
      this.searchFilter = '';
      this.$emit('selected', this.selected);
    },
    showOptions() {
      if (!this.disabled) {
        this.searchFilter = '';
        this.optionsShown = true;
      }
    },
    reset() {
      this.selected = '';
      this.isSelected = false;
      this.searchFilter = '';
      this.optionsShown = false;
      this.$emit('selected', '');

      this.$nextTick(() => {
        this.isSelected = false;
      });
    },
    blur() {
      if (this.selected === '') {
        this.selected = '';
        this.isSelected = false;
        this.searchFilter = '';
        this.$emit('selected', '');
      } else {
        this.searchFilter = this.selected;
        this.isSelected = true;
      }
      this.optionsShown = false;
    },
    // Selecting when pressing Enter
    keyMonitor: function (event) {
      if (event.key === "Enter" && this.filteredOptions[0])
        this.selectOption(this.filteredOptions[0]);
    }
  },
  watch: {
    searchFilter(oldVal, newVal) {
      this.$emit('filter', this.searchFilter);
    }
  }
};
</script>


<style lang="scss" scoped>
@import '../../../../../../Private/Scss/variables/variables';

.dropdown {
  border-bottom: 1px solid #F05A00;
  margin: 0 30px 5px 0;
  position: relative;
  width: 250px;
  @media screen and (max-width: $lg) {
    border-bottom: 1px solid white;
    margin: 0 0 15px 0;
    width: 100%;
  }

  &:after {
    content: "";
    position: absolute;
    right: 0;
    top: 15px;
    color: #F05A00;
    border-top: 5px solid;
    border-right: 5px solid transparent;
    border-bottom: 0;
    border-left: 5px solid transparent;
    margin-left: -15px;
  }

  &:hover {
    background: transparent;
  }

  .dropdown-input {
    background: none;
    border: 0;
    color: #1e1e1e;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    width: calc(250px - 18px);
    padding: 6px 20px 6px 0;
    white-space: nowrap;
    overflow-x: hidden;
    overflow-y: auto;
    outline: none;
    text-overflow: ellipsis;

    &:focus-visible, &:focus {
      outline: none;
    }

    @media screen and (max-width: $lg) {
      color: white;
      min-width: calc(100% - 18px);
    }
  }

  .dropdown-reset {
    cursor: pointer;
    padding: 6px 6px 6px 0;
    @media screen and (max-width: $lg) {
      color: white;
    }
  }

  .dropdown-content {
    background-color: #fff;
    border: 1px solid #e7ecf5;
    box-shadow: 0px -8px 34px 0px rgba(0, 0, 0, 0.05);
    display: block;
    width: auto;
    overflow: auto;
    min-width: 318px;
    position: absolute;
    z-index: 2;
    max-height: 450px;
    box-shadow: 3px 4px 26px -2px rgba(0, 0, 0, 0.75);
    -webkit-box-shadow: 3px 4px 26px -2px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 3px 4px 26px -2px rgba(0, 0, 0, 0.75);
    @media screen and (max-width: $lg) {
      width: 100%;

    }

    .dropdown-item {
      color: #1e1e1e;
      cursor: pointer;
      display: block;
      font-size: 16px;
      line-height: 1em;
      padding: 10px;
      pointer-events: all;
      text-decoration: none;

      &:hover {
        background: $mt-orange;
        color: #fff;
      }
    }
  }

  .dropdown:hover .dropdowncontent {
    display: block;
  }
}
</style>
